import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import store, { persistor } from './redux/store/store';
import { Provider } from 'react-redux';
import axiosInterceptors from "./services/config/axiosInterceptors";
import { PersistGate } from 'redux-persist/integration/react';

import Alert from 'components/Alert/Alert';
import Loader from 'components/Loader/Loader';
import Toast from "components/Toast/Toast";
import InlineLoader from "components/Loader/InlineLoader";
import EmployeeInf from "./views/Employee/EmployeeInf";
import CountScreen from "./views/CountScreen/CountScreen";
import "assets/scss/material-dashboard-pro-react.scss?v=1.9.0";

const AuthLayout = lazy(() => import("layouts/Auth.js"));
// const HomeLayout = lazy(() => import("layouts/Home.js"));


axiosInterceptors.interceptor(store);

const hist = createBrowserHistory();


ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Suspense fallback={<InlineLoader />}>
        <Alert />
        <Loader />
        <Toast />
        <Router history={hist}>
          <Switch>
            <Route path="/auth" component={AuthLayout} />
            <Route path={["/home", "/employee"]} component={EmployeeInf} />
            <Route path={["/home", "/countscreen/Countscreen"]} component={CountScreen } />
            <Redirect from="/" to="/auth/login" />
          </Switch>
        </Router>
      </Suspense>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);